/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 全局注册组件
 */

import cascader from './formComponents/cascader/index.vue';
import enuSelect from './formComponents/enuSelect/index.vue';
import jhTable from './formComponents/table/index.vue';
import jhNumber from './formComponents/number/index.vue';
import baseDialog from './baseDialog/index.vue';
import pager from './formComponents/pager/index.vue';
// import previewFile from './previewFile/index.vue'
import jhColumn from './formComponents/table/column/index.vue';
import jigsaw from './jigsaw/index.vue';
// import uploader from './uploader/index.vue';
import jhFileUpload from './uploader/fileUpload.vue';
import jhBigFileUpload from './uploader/bigFile.vue';
import jhSearchBox from './searchBox/searchBox.vue';
import jhButton from './searchBox/searchButton.vue';
import jhDatePicker from './datePicker/datePicker.vue';
function registerCpt(Vue) {
  if (registerCpt.installed) {
    return;
  }
  Vue.component('jh-date-picker', jhDatePicker);
  Vue.component('jh-search-box', jhSearchBox);
  Vue.component('jh-button', jhButton);
  Vue.component('jh-tool-cascader', cascader);
  // eslint-disable-next-line vue/multi-word-component-names
  Vue.component('cascader', cascader);
  Vue.component('enuSelect', enuSelect);
  Vue.component('jh-table', jhTable);
  Vue.component('jh-number', jhNumber);
  Vue.component('BaseDialog', baseDialog);
  // eslint-disable-next-line vue/multi-word-component-names
  Vue.component('pager', pager);
  Vue.component('jh-cascader', cascader);
  Vue.component('jh-enu-select', enuSelect);
  Vue.component('jh-table', jhTable);
  Vue.component('jh-number', jhNumber);
  Vue.component('jh-base-dialog', baseDialog);
  Vue.component('jh-pager', pager);
  // Vue.component('previewFile',previewFile);
  Vue.component('jh-column', jhColumn);
  // Vue.component('jh-uploader', uploader);
  Vue.component('jh-file-upload', jhFileUpload);
  Vue.component('jh-big-file-upload', jhBigFileUpload);
  // eslint-disable-next-line vue/multi-word-component-names
  Vue.component('jigsaw', jigsaw);
}
export default registerCpt;
